import React, { useEffect, useState } from "react";
import TooltipWrapper from "../TooltipWrapper";

import { useMutation } from "react-query";
import { Checkbox } from "../../ui/checkbox";
import { updateCRMRecord } from "../../../apis/crm";
import dayjs from "dayjs";

export default function UpdateRecord({
  closeModal,
  record,
  diffData,
  payload,
  activeCrm,
  activeWorkspace,
  onSuccess,
  source = "",
}) {
  const [changeApprovals, setChangeApprovals] = useState({});

  // Initialize the state with keys from diffData using the nested 'key' from each object
  useEffect(() => {
    const initialApprovals = Object.entries(diffData).reduce((acc, [key, value]) => {
      acc[key] = true; // Use the nested 'key' for each entry's unique identifier
      return acc;
    }, {});
    setChangeApprovals(initialApprovals);
  }, [diffData]); // Dependency on diffData to reset state when diffData changes

  const handleCheckboxChange = (key) => {
    setChangeApprovals((prev) => ({
      ...prev,
      [key]: !prev[key], // Toggle the approval state for the given key
    }));
  };

  const checkIfAnyTrue = (obj) => {
    return Object.values(obj).some((value) => value === true);
  };

  // update record

  const updateRecordInCRMFn = useMutation("update_data_in_crm", updateCRMRecord, {
    onSuccess(data, variables, context) {
      onSuccess();
      closeModal();
    },
    onError(error) {
      console.log(error);
    },
  });

  const handleUpdateRecordInCRM = () => {
    let updatePayload = payload;
    if (checkIfAnyTrue(changeApprovals)) {
      updatePayload.field_update_preferences = changeApprovals;
    } else {
      if (updatePayload.field_update_preferences) {
        delete updatePayload.field_update_preferences;
      }
    }
    // console.log({ updatePayload, changeApprovals });
    updateRecordInCRMFn.mutate({
      data: updatePayload,
      configId: activeCrm,
      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
    });
  };

  const diffArr = (arr, diff) => {
    if (arr && arr.length > 0 && diff) {
      try {
        const arrayKeys = arr.map((item) => item.key);

        const filteredDiff = Object.keys(diff)
          .filter((diffKey) => !arrayKeys.includes(diffKey))
          .reduce((acc, diffKey) => {
            acc[diffKey] = diff[diffKey];
            return acc;
          }, {});

        return filteredDiff;
      } catch (err) {
        return {};
      }
    }
    return {};
  };

  return (
    <div className=" p-6">
      <div className="bg-gray-50 -mx-6 p-6 border-b border-border -mt-6 mb-4">
        {source !== "app" && (
          <span
            className="flex items-center cursor-pointer mb-4 text-sm space-x-2"
            onClick={() => {
              closeModal();
            }}
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M2.5 7.49996H13.75C15.8211 7.49996 17.5 9.17889 17.5 11.25C17.5 13.321 15.8211 15 13.75 15H10M2.5 7.49996L5.83333 4.16663M2.5 7.49996L5.83333 10.8333"
                stroke="var(--gray-600)"
                stroke-width="1.66667"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span>Back</span>
          </span>
        )}
        <div className="flex items-start space-x-2">
          <div>
            <p className="text-sm font-semibold text-gray-900">Update record</p>
            <p className="text-sm mt-2">Choose fields that will be updated in the CRM record</p>
          </div>
        </div>
      </div>

      <div className=" bg-background rounded-xl mb-4">
        <div className="space-y-2">
          {record &&
            record.length > 0 &&
            record.map((item) => (
              <>
                {diffData[item?.key] && diffData[item?.key].new_value !== item?.value && (
                  <div className="space-y-1 mb-3">
                    <span className="text-sm flex items-center w-full">
                      <Checkbox
                        checked={changeApprovals[item?.key] || false}
                        onCheckedChange={() => handleCheckboxChange(item?.key)}
                      />
                      <span className="ml-2">{item?.label}:</span>
                    </span>
                    <span className="text-gray-900 text-sm font-semibold break-words block">
                      <div className="rounded overflow-hidden">
                        <TooltipWrapper content={"Current data in CRM record"} className="w-full">
                          <span className="bg-error-50 py-1 px-2 flex items-center">
                            <span className="inline-flex border border-error-200 bg-error-50 text-error-700 text-[9px] py-0.5 px-1 rounded-lg leading-none mr-1">
                              Now
                            </span>
                            <span className="text-gray-600 font-normal flex-1 whitespace-break-spaces text-left pr-word-break">
                              {/* {diffData[item?.key]?.existing_value} */}
                              {diffData[item?.key]?.existing_value
                                ? typeof diffData[item?.key]?.existing_value === "string" &&
                                  dayjs(diffData[item?.key]?.existing_value).isValid() &&
                                  diffData[item?.key]?.existing_value.includes("T")
                                  ? dayjs(diffData[item?.key]?.existing_value).format(
                                      "DD MMM YYYY, hh:mm:ss A"
                                    )
                                  : diffData[item?.key]?.existing_value
                                : "-"}
                            </span>
                          </span>
                        </TooltipWrapper>
                        <TooltipWrapper content={"Latest refreshed data"} className="w-full">
                          <span className="bg-success-50 py-1 px-2 flex items-center">
                            <span className="inline-flex border border-success-200 bg-success-50 text-success-700 text-[9px] py-0.5 px-1 rounded-lg leading-none mr-1">
                              New
                            </span>

                            <span className="text-gray-600 font-normal flex-1 whitespace-break-spaces text-left pr-word-break">
                              {diffData[item?.key]?.new_value
                                ? typeof diffData[item?.key]?.new_value === "string" &&
                                  dayjs(diffData[item?.key]?.new_value).isValid() &&
                                  diffData[item?.key]?.new_value.includes("T")
                                  ? dayjs(diffData[item?.key]?.new_value).format("DD MMM YYYY, hh:mm:ss A")
                                  : diffData[item?.key]?.new_value
                                : "-"}
                            </span>
                          </span>
                        </TooltipWrapper>
                      </div>
                    </span>
                  </div>
                )}
              </>
            ))}
          {record &&
            record.length > 0 &&
            diffArr(record, diffData) &&
            Object.keys(diffArr(record, diffData)).length > 0 &&
            Object.entries(diffArr(record, diffData)).map(([key, value]) => (
              <div className="space-y-1 mb-3">
                <span className="text-sm flex items-center w-full">
                  <Checkbox
                    checked={changeApprovals[key] || false}
                    onCheckedChange={() => handleCheckboxChange(key)}
                  />
                  <span className="ml-2">{value?.label || key}:</span>
                </span>
                <span className="text-gray-900 text-sm font-semibold break-words block">
                  <div className="rounded overflow-hidden">
                    <TooltipWrapper content={"Current data in CRM record"} className="w-full">
                      <span className="bg-error-50 py-1 px-2 flex items-center">
                        <span className="inline-flex border border-error-200 bg-error-50 text-error-700 text-[9px] py-0.5 px-1 rounded-lg leading-none mr-1">
                          Now
                        </span>
                        <span className="text-gray-600 font-normal flex-1 whitespace-break-spaces text-left pr-word-break">
                          {diffArr(record, diffData)[key]?.existing_value
                            ? typeof diffArr(record, diffData)[key]?.existing_value === "string" &&
                              dayjs(diffArr(record, diffData)[key]?.existing_value).isValid() &&
                              diffArr(record, diffData)[key]?.existing_value.includes("T")
                              ? dayjs(diffArr(record, diffData)[key]?.existing_value).format(
                                  "DD MMM YYYY, hh:mm:ss A"
                                )
                              : diffArr(record, diffData)[key]?.existing_value
                            : "-"}
                        </span>
                      </span>
                    </TooltipWrapper>
                    <TooltipWrapper content={"Latest refreshed data"} className="w-full">
                      <span className="bg-success-50 py-1 px-2 flex items-center">
                        <span className="inline-flex border border-success-200 bg-success-50 text-success-700 text-[9px] py-0.5 px-1 rounded-lg leading-none mr-1">
                          New
                        </span>

                        <span className="text-gray-600 font-normal flex-1 whitespace-break-spaces text-left pr-word-break">
                          {diffArr(record, diffData)[key]?.new_value
                            ? typeof diffArr(record, diffData)[key]?.new_value === "string" &&
                              dayjs(diffArr(record, diffData)[key]?.new_value).isValid() &&
                              diffArr(record, diffData)[key]?.new_value.includes("T")
                              ? dayjs(diffArr(record, diffData)[key]?.new_value).format(
                                  "DD MMM YYYY, hh:mm:ss A"
                                )
                              : diffArr(record, diffData)[key]?.new_value
                            : "-"}
                        </span>
                      </span>
                    </TooltipWrapper>
                  </div>
                </span>
              </div>
            ))}
        </div>
        <div className="flex space-x-3 mt-6 border-t pt-6">
          <button
            disabled={!checkIfAnyTrue(changeApprovals)}
            onClick={() => {
              !updateRecordInCRMFn.isLoading && handleUpdateRecordInCRM();
            }}
            className="text-[14px] disabled:opacity-70 flex w-full justify-center items-center py-2 h-9 space-x-2 px-4 rounded-[8px] text-white bg-brand-600 dark:bg-brand-300 border border-brand-600 font-semibold"
          >
            Update CRM record
            {updateRecordInCRMFn.isLoading && <div className="loader_circle inline-block ml-2"></div>}
          </button>
          <button
            onClick={closeModal}
            className="flex justify-center items-center whitespace-nowrap text-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 border bg-background  text-gray-600 px-4 py-2 h-9 rounded-[8px] font-semibold"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
